import React, {useContext, useEffect} from "react";
import {ProductInterface as CatalogProductInterface} from "../interfaces/catalog/ProductInterface";
import useLocalStorage from "../utils/useLocalStorage";
import {BasketItemInterface} from "../interfaces/checkout/BasketItemInterface";
import {GlobalContext, ReducerActionType} from "../GlobalReducer";
import {
    LOCAL_STORAGE_KEY_BASKET,
    LOCAL_STORAGE_KEY_BASKET_LIST,
    LOCAL_STORAGE_KEY_COMPARISON, LOCAL_STORAGE_KEY_CUSTOMER,
    LOCAL_STORAGE_KEY_FAVORITE
} from "../Config";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {BasketInterface} from "../interfaces/checkout/BasketInterface";
import {getCredentials} from "../api/customer";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";

export default function ObjectStorage()
{
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {setItems: setLocalStorageItems, getItems: getLocalStorageItems, setObject: setLocalStorageObject, getObject: getLocalStorageObject} = useLocalStorage()

    useEffect(() => {
        const favoriteFromStorage = getLocalStorageItems(LOCAL_STORAGE_KEY_FAVORITE);
        if (favoriteFromStorage.length) {
            dispatch({type: ReducerActionType.SET_FAVORITES, payload: favoriteFromStorage.map(id => ({id: parseInt(id)} as CatalogProductInterface))});
        }
        const comparisonFromStorage = getLocalStorageItems(LOCAL_STORAGE_KEY_COMPARISON);
        if (comparisonFromStorage.length) {
            dispatch({type: ReducerActionType.SET_COMPARISON, payload: comparisonFromStorage.map(id => ({id: parseInt(id)} as CatalogProductInterface))});
        }
        const basketFromStorage = getLocalStorageObject(LOCAL_STORAGE_KEY_BASKET);
        if (basketFromStorage.length) {
            dispatch({type: ReducerActionType.SET_BASKET, payload: basketFromStorage as BasketItemInterface[]});
        }

        const customerFromStorage = getLocalStorageObject(LOCAL_STORAGE_KEY_CUSTOMER) as CustomerInterface | null;
        if (customerFromStorage && customerFromStorage.id) {
            dispatch({type: ReducerActionType.SET_CUSTOMER, payload: customerFromStorage});
            getCredentials(customerFromStorage).then(response => {
                if (response?.status === 'fail') {
                    dispatch({type: ReducerActionType.SET_CUSTOMER, payload: null});
                    localStorage.removeItem(LOCAL_STORAGE_KEY_CUSTOMER);
                } else if (response?.customer) {
                    dispatch({type: ReducerActionType.SET_CUSTOMER, payload: response.customer});
                }
            }).catch((error) => {
                console.log(error);
                const data = error?.response?.data;
                if (data?.status === 'fail') {
                    dispatch({type: ReducerActionType.SET_CUSTOMER, payload: null});
                    localStorage.removeItem(LOCAL_STORAGE_KEY_CUSTOMER);
                }
            });
        }
    }, []);

    useEffect(() => {
        setLocalStorageItems(LOCAL_STORAGE_KEY_FAVORITE, state.favorites.map((item: CatalogProductInterface) => item.id.toString()));
    }, [state.favorites]);

    useEffect(() => {
        setLocalStorageItems(LOCAL_STORAGE_KEY_COMPARISON, state.comparison.map((item: CatalogProductInterface) => item.id.toString()));
    }, [state.comparison]);

    useEffect(() => {
        setLocalStorageObject(LOCAL_STORAGE_KEY_CUSTOMER, state.customer);
    }, [state.customer]);

    useEffect(() => {
        const toSave = state.basket.map((item: BasketItemInterface) => {
            return {
                product: {
                    id: item.product.id,
                    name: item.product.name,
                    list_image: item.product.list_image,
                    current_price: item.product.current_price,
                    base_price: item.product.base_price,
                },
                quantity: item.quantity,
                createdAt: item.createdAt,
            } as BasketItemInterface
        })
        setLocalStorageObject(LOCAL_STORAGE_KEY_BASKET, toSave);

        const currentBasketList: BasketInterface[] = getLocalStorageObject(LOCAL_STORAGE_KEY_BASKET_LIST) || [];

        if(currentBasketList?.length && state.basket.length > 0){
            const newBasketList = currentBasketList.filter(basket => !basket.isActive);
            const currentBasket = currentBasketList.find(basket => basket.isActive);
            newBasketList.push({...currentBasket, items: toSave, updatedAt: new Date().toISOString() } as BasketInterface);
            console.log('>>>', newBasketList)
            setLocalStorageObject(LOCAL_STORAGE_KEY_BASKET_LIST, newBasketList);
        }


    }, [state.basket]);

    return null

}